import { RouteFactory } from "@app/routePaths";
import AboutUsLayout from "@routes/Content/layout/AboutUsLayout/AboutUsLayout";
import AdvertiseLayout from "@routes/Content/layout/AdvertiseLayout";
import ContactUsPage from "@routes/Content/layout/ContactUsLayout";
import FAQPrLayout from "@routes/Content/layout/FAQPrLayout";
import HelpPage from "@routes/Content/layout/HelpLayout";
import RssFeedsPage from "@routes/Content/layout/RssFeedsLayout/RssFeedsLayout";

type LayoutFactoryProps = {
  /**  The path of the page. */
  urlPath: string;
};

/**
 * This is the factory for the layout components.
 */
const LayoutFactory = ({ urlPath }: LayoutFactoryProps): React.ReactElement => {
  if (urlPath === RouteFactory.help) {
    return <HelpPage />;
  }

  if (urlPath === RouteFactory.faqPressRelease) {
    return <FAQPrLayout />;
  }

  if (urlPath === RouteFactory.contactUs) {
    return <ContactUsPage />;
  }

  if (urlPath === RouteFactory.aboutUs) {
    return <AboutUsLayout />;
  }

  if (urlPath === RouteFactory.advertise) {
    return <AdvertiseLayout />;
  }

  if (urlPath === RouteFactory.rssFeeds) {
    return <RssFeedsPage />;
  }

  return <></>;
};

export default LayoutFactory;
